import { BlockType } from '@sharedTypes';

export type TextFieldType = 'text' | 'phonenumber' | 'email';

type ValidationRule<T> = { value: T; message: string };

type HasValidationFailedMessage = {
  message: string;
};

type ValidationMaxFileSizeRule = HasValidationFailedMessage & {
  value: number;
};

type ValidationFileTypeRule = {
  value: string;
};

export type Rules = Partial<{
  required: ValidationRule<boolean>;
  min: ValidationRule<number>;
  max: ValidationRule<number>;
  validate: HasValidationFailedMessage;
  maxFileSize: ValidationMaxFileSizeRule;
  fileType: ValidationFileTypeRule;
  singleEmoji: HasValidationFailedMessage;
}>;

export type BaseInputField = {
  id: string;
  label: string;
  step: number;
  rules?: Rules;
};

export type TextField = BaseInputField & {
  type: TextFieldType;
  placeholder: string;
};

export type TextAreaField = BaseInputField & {
  type: 'textarea';
  placeholder: string;
};

export type RadioGroupField = BaseInputField & {
  direction: 'column' | 'row';
  radioFields: RadioField[];
  type: 'radio';
};

export type RadioField = {
  name: string;
  label: string;
  value: string;
};

type InputFieldGroup = {
  type: 'group';
  step: number;
  group: InputField[];
};

export enum DocumentType {
  Resume = 'RESUME',
  CoverLetter = 'COVER_LETTER',
  Generic = 'GENERIC'
}

type FileInputField = {
  id: string;
  type: 'file';
  documentType: DocumentType;
  label: string;
  title: string;
  rules?: Rules;
};

type MatrixField = {
  id: string;
  type: 'matrix';
  label: string;
  rules?: Rules;
  info?: string;
};

export type InputField = {
  type: TextFieldType | 'textarea' | 'radio' | 'group' | 'file' | 'matrix';
  questionType?: 'default' | 'screening';
} & (TextField | TextAreaField | RadioGroupField | InputFieldGroup | FileInputField | MatrixField);

export type ApplicationFormBlock = LocationSpecificApplicationFormBlock | GroupApplicationFormBlock;

export type ApplicationFailureMessage = {
  title: string;
  text: string;
};

export type PrivacyStatement = {
  label: string;
  rules?: { required: ValidationRule<boolean> };
};

export type SubmitButton = {
  value: string;
};

export type DefaultApplicationFormBlock = {
  type: BlockType.Application;
  title: string;
  failureMessage: ApplicationFailureMessage;
  inputFields: InputField[];
  privacyStatement: PrivacyStatement;
  submitButton: SubmitButton;
};

export type LocationSpecificApplicationFormBlock = DefaultApplicationFormBlock & {
  vacancyId: string;
};
export type GroupApplicationFormBlock = DefaultApplicationFormBlock & {
  locationOptions: { name: string; vacancyId: string }[];
};
